import { render, staticRenderFns } from "./ConfigSlideShowAdd.vue?vue&type=template&id=606b5940&scoped=true&"
import script from "./ConfigSlideShowAdd.vue?vue&type=script&lang=js&"
export * from "./ConfigSlideShowAdd.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSlideShowAdd.vue?vue&type=style&index=0&id=606b5940&scoped=true&lang=css&"
import style1 from "./ConfigSlideShowAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b5940",
  null
  
)

export default component.exports